import { c as _c } from "react/compiler-runtime";
import type { Ref } from "react";
import { SearchIcon } from "@local/ui/src/components/ui/icons";
import { cn } from "@local/utils/src/cn";
interface SearchButtonProps {
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
  ariaLabel?: string;
  ref?: Ref<HTMLButtonElement>;
}
export const SearchButton = t0 => {
  const $ = _c(12);
  const {
    onClick,
    className,
    iconClassName,
    ariaLabel: t1,
    ref
  } = t0;
  const ariaLabel = t1 === undefined ? "Search" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("p-2 transition-opacity hover:opacity-75", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== iconClassName) {
    t3 = cn("h-4 w-4", iconClassName);
    $[2] = iconClassName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <SearchIcon className={t3} aria-hidden="true" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== ariaLabel || $[7] !== onClick || $[8] !== ref || $[9] !== t2 || $[10] !== t4) {
    t5 = <button ref={ref} type="button" className={t2} aria-label={ariaLabel} onClick={onClick}>{t4}</button>;
    $[6] = ariaLabel;
    $[7] = onClick;
    $[8] = ref;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};